module.exports = __webpack_public_path__ + "static/media/nt_logo_blue.d166e222.svg";